import { Licensee } from "./Licensee.model";
import { ReportingPeriod } from "./ReportingPeriod.model";
import { DataValidationLog } from "./DataValidationLog.model";

export class SubmissionReport {
    licensee: Licensee;
    reportingperiod: ReportingPeriod;
    log: Array<DataValidationLog>;
}
